import { useTrackIdUpdateLink } from '@/utils/useTrackIdUpdateLink';
import { styled } from '@mui/system';
import dynamic from 'next/dynamic';
import { useRef } from 'react';
import { pr } from '@/utils/pxToRem';
import SearchFlightTab from '@/containers/SearchFlightTabVcms';
import BusIcon from '@mui/icons-material/DirectionsBus';
import FlightIcon from '@mui/icons-material/Flight';
import TrainIcon from '@mui/icons-material/Train';
import CustomTabs from '../Tabs';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const StyledWrapper = styled('div')({
  background: '#FFFFFF',
});

const HeaderTabsVcms = ({
  disableIcon, filterAirline, onSearchClick, onClickTab, lang, startPoint, toPoint, isFirstTime, switchUpdateSecondTime, statePassenger,
  stateSeatClass,
}: { statePassenger: any, stateSeatClass: any, switchUpdateSecondTime: any, startPoint: any, toPoint: any, disableIcon?: boolean, filterAirline?: string[], lang?: ILangObj, onSearchClick?: any, onClickTab?: (newTab: string) => void, isFirstTime: boolean }) => {
  const id = 'tim-chuyen';
  const ref = useRef(null) as any;
  useTrackIdUpdateLink(ref, id);

  return (
    <StyledWrapper
      id={id}
      ref={ref}
    >
      <div style={{
        // padding: pr`16px`,
        paddingBottom: 0,
      }}
      >
        {/* <CustomTabs
          onClickTab={onClickTab}
          labelObjs={[{
            type: 'flight',
            icon: disableIcon ? null : <FlightIcon />,
          }]}
          tabComponent={[
            <SearchFlightTab
              onSearchClick={onSearchClick}
              key="searchFlightTab"
              isCallFromHomepage
            />,
          ]}
        /> */}
        <SearchFlightTab
          onSearchClick={onSearchClick}
          key="searchFlightTab"
          isCallFromHomepage
          // isVcms
          lang={lang}
          startPointSeo={startPoint}
          toPointSeo={toPoint}
          isFirstTime={isFirstTime}
          switchUpdateSecondTime={switchUpdateSecondTime}
          statePassengerSeo={statePassenger}
          stateSeatClassSeo={stateSeatClass}
          // filterAirline={filterAirline}
        />
      </div>
    </StyledWrapper>
  );
};

export default HeaderTabsVcms;
